import Vue from 'vue'
import Router from 'vue-router'
//授权
import author from '@/views/author/author'

// 首页模块
import index from '@/views/index/index'   //首页
import share from '@/views/index/share'   //合伙分享
import partnerApply from '@/views/index/partnerApply'   //创客合伙人
import search from '@/views/index/search'   //创客合伙人

// 预约模块
import book from '@/views/book/book'      //预约
import storeList from '@/views/book/store/storeList'    //门店列表列表
import storeDetails from '@/views/book/store/storeDetails'    //门店详情
import itemList from '@/views/book/item/itemList'    //（服务）项目列表
import itemDetails from '@/views/book/item/itemDetails'    //（服务）项目详情
import technicianList from '@/views/book/technician/technicianList'    //技师列表
import technicianDetails from '@/views/book/technician/technicianDetails'    //技师详情
import evaluate from '@/views/book/evaluate'      //评价
import bookOrder from '@/views/book/bookOrder'      //预约订单
import selectStore from '@/views/book/selectStore'      //选择门店
import selectTime from '@/views/book/selectTime'      //选择时间
import selectTech from '@/views/book/selectTech'      //选择技师
import selectCoupon from '@/views/book/selectCoupon'      //选择代金券
// 资讯模块
import message from '@/views/message/message'    //资讯
import videoDetails from '@/views/message/videoDetails'    //视频详情
import articleDetails from '@/views/message/articleDetails'    //文章详情
// 订单模块
import order from '@/views/order/order'     //订单
import checkservice from '@/views/order/checkservice' //订单-确认服务
import orderDetails from '@/views/order/orderDetails' //订单详情
import comment from '@/views/order/comment' //订单评价
import chooseTech from '@/views/order/chooseTech'//重新选择技师
/* 个人中心模块*/
import center from '@/views/center/center'     //个人中心
import uplevel from '@/views/center/uplevel' //购买分销资格
import recharge from '@/views/center/recharge' //用户充值
import gorecharge from '@/views/center/gorecharge' //去用户充值页面
import balance from '@/views/center/balance' //我的余额
import history from '@/views/center/history' //浏览记录
import coupon from '@/views/center/coupon' //我的优惠券
import recommend from '@/views/center/recommend/recommend' //我的推荐
import withdrawal from '@/views/center/recommend/withdrawal' //提现
import commission_qrcode from '@/views/center/recommend/commission_qrcode' //分享码
import commission_income from '@/views/center/recommend/commission_income' //分享收入
import withdrawal_log from '@/views/center/recommend/withdrawal_log' //提现明细
import down from '@/views/center/recommend/down' //下级盟友
/* 技师中心模块*/
import tech_center from '@/views/technician/tech_center' //技师中心
import tech_payservice from '@/views/technician/payservice' //技师取消支付页
import tech_order from '@/views/technician/order/tech_order' //技师订单
import tech_detail from '@/views/technician/order/tech_detail' //技师订单详情
import tech_selectStore from '@/views/technician/tech_selectStore' //技师选择门店
import tech_income from '@/views/technician/tech_income' //技师收入
import tech_data from '@/views/technician/perData/tech_data' //技师资料
import editpersonal from '@/views/technician/perData/editpersonal' //技师个人介绍修改
import editworkinfo from '@/views/technician/perData/editworkinfo' //技师从业信息修改
import editserviceinfo from '@/views/technician/perData/editserviceinfo' //技师服务信息修改
import tech_apply from '@/views/technician/apply' //共享技师门店申请
import tech_authentication from '@/views/technician/authentication' //技师申请身份验证
import tech_applyinfo from '@/views/technician/applyinfo' //技师申请个人信息
import tech_upload from '@/views/technician/upload' //技师证件上传
import techAvatar from '@/views/technician/perData/techAvatar' //技师更改头像
import tech_withdrawal from '@/views/technician/withdrawal' //技师收入提现
import tech_withdrawal_log from '@/views/technician/withdrawal_log' //技师收入明细
import tech_agreement from '@/views/technician/agreement' //技师合作协议


// 门店模块
import  storeCenter from  '@/views/store/storeCenter'  //门店中心
import store_order from '@/views/store/order/store_order' //门店订单
import store_orderDetails from '@/views/store/order/store_orderDetails' //门店订单详情
import store_tech from '@/views/store/store_tech' //门店技师管理
import store_selectItem from '@/views/store/store_selectItem' //门店选择项目
import store_income from '@/views/store/store_income' //门店分成收入
import performanceCheck from '@/views/store/performanceCheck' //门店业绩查看
import storeApply from '@/views/store/storeApply' //门店申请
import storeInfo from '@/views/store/storeInfo' //门店信息
import storeInfo_intro from '@/views/store/storeInfo_intro' //门店信息-编辑简介
import store_withdrawal from '@/views/store/withdrawal' //门店信息-提现
import storeAvatar from '@/views/store/storeAvatar' //上传门店头像
import store_qrcode from '@/views/center/recommend/store_qrcode' //推荐门店


Vue.use(Router);


export default new Router({
  // mode: 'history',
  // base: './',
  routes: [
	  {
	    path: '/author',
	    name: 'author',
	    component:author,
	    meta: {
	      title: '微信授权'
	    }
	  },
    {
      path: '/',
      name: '/',
      redirect: '/index',
      component: index,
      meta: {
        title: '柳安堂'
      }
    },{
      path: '/index',
      name: 'index',
      component: index,
      meta: {
        title: '柳安堂'
      }
    },{
      path: '/search',
      name: 'search',
      component: search,
      meta: {
        title: '搜索'
      }
    },{
      path: '/book',
      name: 'book',
      component: book,
      meta: {
        title: '预约'
      }
    },{
      path: '/message',
      name: 'message',
      component: message,
      meta: {
        title: '资讯'
      }
    },{
      path: '/order',
      name: 'order',
      component: order,
      meta: {
        title: '订单'
      }
    },{
      path: '/center',
      name: 'center',
      component: center,
      meta: {
        title: '我的'
      }
    },{
      path: '/storeList',
      name: 'storeList',
      component: storeList,
      meta: {
        title: '养生体验店'
      }
    },{
      path: '/storeDetails',
      name: 'storeDetails',
      component: storeDetails,
      meta: {
        title: '门店详情'
      }
    },{
      path: '/itemList',
      name: 'itemList',
      component: itemList,
      meta: {
        title: '养生服务'
      }
    },{
      path: '/itemDetails',
      name: 'itemDetails',
      component: itemDetails,
      meta: {
        title: '项目详情'
      }
    },{
      path: '/technicianList',
      name: 'technicianList',
      component: technicianList,
      meta: {
        title: '养生技师'
      }
    },{
      path: '/technicianDetails',
      name: 'technicianDetails',
      component: technicianDetails,
      meta: {
        title: '技师详情'
      }
    },{
      path: '/evaluate',
      name: 'evaluate',
      component: evaluate,
      meta: {
        title: '评价'
      }
    },{
      path: '/bookOrder',
      name: 'bookOrder',
      component: bookOrder,
      meta: {
        title: '预约订单'
      }
    },{
      path: '/selectStore',
      name: 'selectStore',
      component: selectStore,
      meta: {
        title: '选择门店'
      }
    },{
      path: '/selectTime',
      name: 'selectTime',
      component: selectTime,
      meta: {
        title: '选择时间'
      }
    },{
      path: '/selectTech',
      name: 'selectTech',
      component: selectTech,
      meta: {
        title: '选择技师'
      }
    },{
      path: '/selectCoupon',
      name: 'selectCoupon',
      component: selectCoupon,
      meta: {
        title: '选择代金券'
      }
    },{
      path: '/videoDetails',
      name: 'videoDetails',
      component: videoDetails,
      meta: {
        title: '视频详情'
      }
    },{
      path: '/articleDetails',
      name: 'articleDetails',
      component: articleDetails,
      meta: {
        title: '文章详情'
      }
    },{
      path: '/share',
      name: 'share',
      component: share,
      meta: {
        title: '合伙分享'
      }
    },{
      path: '/partnerApply',
      name: 'partnerApply',
      component: partnerApply,
      meta: {
        title: '创客合伙人'
      }
    },



    {
      path: '/comment',
      name: 'comment',
      component: comment,
      meta: {
        title: '订单评价'
      }
    },
    {
      path: '/chooseTech',
      name: 'chooseTech',
      component: chooseTech,
      meta: {
        title: '重新选择技师'
      }
    },
    {
      path: '/uplevel',
      name: 'uplevel',
      component: uplevel,
      meta: {
        title: '购买分销资格'
      }
    },
    {
      path: '/balance',
      name: 'balance',
      component: balance,
      meta: {
        title: '我的余额'
      }
    },
    {
      path: '/history',
      name: 'history',
      component: history,
      meta: {
        title: '浏览记录'
      }
    },
    {
      path: '/coupon',
      name: 'coupon',
      component: coupon,
      meta: {
        title: '我的优惠券'
      }
    },
    {
      path: '/recommend',
      name: 'recommend',
      component: recommend,
      meta: {
        title: '我的推荐'
      }
    },
    {
      path: '/withdrawal',
      name: 'withdrawal',
      component: withdrawal,
      meta: {
        title: '提现'
      }
    },
    {
      path: '/commission_qrcode',
      name: 'commission_qrcode',
      component: commission_qrcode,
      meta: {
        title: '分享码'
      }
    },
    {
      path: '/commission_income',
      name: 'commission_income',
      component: commission_income,
      meta: {
        title: '分享收入'
      }
    },
    {
      path: '/withdrawal_log',
      name: 'withdrawal_log',
      component: withdrawal_log,
      meta: {
        title: '提现明细'
      }
    },
    {
      path: '/down',
      name: 'down',
      component: down,
      meta: {
        title: '分享盟友'
      }
    },
    {
      path: '/checkservice',
      name: 'checkservice',
      component: checkservice,
      meta: {
        title: '确认服务'
      }
    },
    {
      path: '/orderDetails',
      name: 'orderDetails',
      component: orderDetails,
      meta: {
        title: '订单详情'
      }
    },
    {
      path: '/tech_center',
      name: 'tech_center',
      component: tech_center,
      meta: {
        title: '技师中心'
      }
    },
    {
      path: '/payservice',
      name: 'tech_payservice',
      component: tech_payservice,
      meta: {
        title: '技师支付订单'
      }
    },
    {
      path: '/tech_order',
      name: 'tech_order',
      component: tech_order,
      meta: {
        title: '技师订单'
      }
    },
    {
      path: '/tech_detail',
      name: 'tech_detail',
      component: tech_detail,
      meta: {
        title: '技师订单详情'
      }
    },
    {
      path: '/tech_income',
      name: 'tech_income',
      component: tech_income,
      meta: {
        title: '技师收入'
      }
    },
    {
      path: '/tech_data',
      name: 'tech_data',
      component: tech_data,
      meta: {
        title: '技师资料'
      }
    }
    ,
    {
      path: '/editpersonal',
      name: 'editpersonal',
      component: editpersonal,
      meta: {
        title: '个人介绍修改'
      }
    },
    {
      path: '/editworkinfo',
      name: 'editworkinfo',
      component: editworkinfo,
      meta: {
        title: '从业信息修改'
      }
    },
    {
      path: '/editserviceinfo',
      name: 'editserviceinfo',
      component: editserviceinfo,
      meta: {
        title: '服务信息修改'
      }
    },
    {
      path: '/recharge',
      name: 'recharge',
      component: recharge,
      meta: {
        title: '用户充值'
      }
    },
    {
      path: '/apply',
      name: 'tech_apply',
      component: tech_apply,
      meta: {
        title: '共享技师门店申请'
      }
    },
    {
      path: '/authentication',
      name: 'tech_authentication',
      component: tech_authentication,
      meta: {
        title: '技师申请身份验证'
      }
    },
    {
      path: '/applyinfo',
      name: 'tech_applyinfo',
      component: tech_applyinfo,
      meta: {
        title: '技师个人信息'
      }
    },
    {
      path: '/upload',
      name: 'tech_upload',
      component: tech_upload,
      meta: {
        title: '技师证件上传'
      }
    },
    {
      path: '/gorecharge',
      name: 'gorecharge',
      component: gorecharge,
      meta: {
        title: '成为分享合伙人'
      }
    },
    {
      path: '/tech_selectStore',
      name: 'tech_selectStore',
      component: tech_selectStore,
      meta: {
        title: '技师选择门店'
      }
    },
    {
      path: '/storeCenter',
      name: 'storeCenter',
      component: storeCenter,
      meta: {
        title: '门店中心'
      }
    },{
      path: '/store_order',
      name: 'store_order',
      component: store_order,
      meta: {
        title: '门店订单'
      }
    },{
      path: '/store_orderDetails',
      name: 'store_orderDetails',
      component: store_orderDetails,
      meta: {
        title: '订单详情'
      }
    },{
      path: '/store_tech',
      name: 'store_tech',
      component: store_tech,
      meta: {
        title: '技师管理'
      }
    },{
      path: '/store_selectItem',
      name: 'store_selectItem',
      component: store_selectItem,
      meta: {
        title: '选择项目'
      }
    },{
      path: '/store_income',
      name: 'store_income',
      component: store_income,
      meta: {
        title: '分成收入'
      }
    },{
      path: '/performanceCheck',
      name: 'performanceCheck',
      component: performanceCheck,
      meta: {
        title: '业绩查看'
      }
    },{
      path: '/storeApply',
      name: 'storeApply',
      component: storeApply,
      meta: {
        title: '门店申请'
      }
    },{
      path: '/storeInfo',
      name: 'storeInfo',
      component: storeInfo,
      meta: {
        title: '门店信息'
      }
    },{
      path: '/storeInfo_intro',
      name: 'storeInfo_intro',
      component: storeInfo_intro,
      meta: {
        title: '门店简介'
      }
    },{
      path: '/store_withdrawal',
      name: 'store_withdrawal',
      component: store_withdrawal,
      meta: {
        title: '门店提现'
      }
    },
    {
      path: '/techAvatar',
      name: 'techAvatar',
      component: techAvatar,
      meta: {
        title: '更换技师头像'
      }
    },
    {
      path: '/tech_withdrawal',
      name: 'tech_withdrawal',
      component: tech_withdrawal,
      meta: {
        title: '技师收入提现'
      }
    },
    {
      path: '/tech_withdrawal_log',
      name: 'tech_withdrawal_log',
      component: tech_withdrawal_log,
      meta: {
        title: '技师收入明细'
      }
    },
    {
      path: '/tech_agreement',
      name: 'tech_agreement',
      component: tech_agreement,
      meta: {
        title: '技师合作协议'
      }
      
    },
    {
      path: '/storeAvatar',
      name: 'storeAvatar',
      component: storeAvatar,
      meta: {
        title: '上传门店头像'
      }
      
    },
    {
      path: '/store_qrcode',
      name: 'store_qrcode',
      component: store_qrcode,
      meta: {
        title: '推荐门店'
      }
      
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js